import React from 'react';
import './About.css';

const About = () => {
  const currentYear = new Date().getFullYear();
  const coreServices = [
    'Direct & Indirect Taxation',
    'Statutory & Internal Audits',
    'Accounting & Bookkeeping Services',
    'Financial Advisory & Financing Assistance',
    'Compliance & Regulatory Support',
    'Business Advisory Services'
  ];

  const teamAreas = [
    'Taxation',
    'Audits',
    'Accountancy',
    'Financing & Advisory'
  ];

  const approachPoints = [
    'Personalized attention to every client',
    'Ethical and transparent practices',
    'Timely delivery of services',
    'Proactive advisory rather than reactive compliance',
    'Long-term professional association'
  ];

  const firmHighlights = [
    { label: 'Established', value: '2012' },
    { label: 'Head Office', value: 'Mumbai' },
    { label: 'Core Focus', value: 'Tax · Audit · Advisory' }
  ];

  return (
    <div className="about-us-page">

      {/* ── HERO TOP SECTION ─────────────────────────────── */}
      <section className="au-hero">
        <div className="container au-hero-grid">

          {/* Hero: heading + intro */}
          <div className="au-hero-left">
            <h1 className="au-hero-heading">ABOUT US</h1>
            <p className="au-hero-eyebrow">Chartered Accountancy &amp; Financial Advisory</p>
            <p className="au-hero-desc">
              M/s. Ritesh Shah &amp; Co. (RSC) is a professionally managed Chartered
              Accountancy firm established in 2012 by CA Ritesh Vijay Shah.
            </p>
          </div>

        </div>
      </section>

      {/* ── PRINCIPALS SECTION ───────────────────────────── */}
      <section className="au-principals-section">
        <div className="container">

          {/* Ritesh – Top Centered */}
          <div className="au-founder-row">
            <div className="au-team-card au-founder-card">
              <div className="au-team-photo-wrap">
                <img src="/riteshphoto.png" alt="CA Ritesh Vijay Shah" className="au-team-photo" />
              </div>
              <h3 className="au-team-name">CA Ritesh Vijay Shah</h3>
              <p className="au-team-role">Founder and Owner</p>
            </div>
          </div>

          {/* Other Principals Grid */}
          <div className="au-team-grid au-team-grid--principals">

            {/* Shruti – Managing Director */}
            <div className="au-team-card">
              <div className="au-team-photo-wrap">
                <img src="/shruti.jpeg" alt="Shruti" className="au-team-photo" />
              </div>
              <h3 className="au-team-name">Shruti Shah</h3>
              <p className="au-team-role">Managing Director</p>
            </div>

            {/* Avinash – Senior Tax Compliance Manager */}
            <div className="au-team-card">
              <div className="au-team-photo-wrap">
                <img src="/avinash.jpeg" alt="Avinash" className="au-team-photo" />
              </div>
              <h3 className="au-team-name">Avinash Patel</h3>
              <p className="au-team-role">Manager</p>
            </div>

          </div>

        </div>
      </section>

      {/* ── CONTENT SECTIONS ─────────────────────────────── */}
      <section className="about-us-content-section">
        <div className="container">

          <article className="about-content-block">
            <h2>Who We Are</h2>
            <p className="about-content-lead">
              RSC is a Mumbai-based Chartered Accountancy firm supporting businesses,
              entrepreneurs, and professionals with practical financial guidance.
            </p>
            <p>
              Since inception, our focus has remained constant: deliver ethical,
              value-driven service with clarity, precision, and long-term reliability.
            </p>

            <div className="about-highlight-grid" aria-label="Firm highlights">
              {firmHighlights.map((item) => (
                <article className="about-highlight-card" key={item.label}>
                  <p>{item.label}</p>
                  <h3>{item.value}</h3>
                </article>
              ))}
            </div>
          </article>

          <div className="about-us-two-col">
            <article className="about-content-card about-content-card--vision">
              <p className="about-card-kicker">Vision</p>
              <h3>Our Vision</h3>
              <p className="about-content-lead">
                To be a dependable and long-term financial partner for our clients by providing comprehensive,
                ethical, and solution-oriented professional services.
              </p>
            </article>

            <article className="about-content-card about-content-card--services">
              <p className="about-card-kicker">Services</p>
              <h3>What We Do</h3>
              <p>
                We offer integrated professional services under one roof so clients can avoid fragmented advice
                and move faster with confidence.
              </p>
              <ul className="about-list about-list--two-col">
                {coreServices.map((service) => (
                  <li key={service}>{service}</li>
                ))}
              </ul>
              <p>
                Our role is to simplify complex regulatory and financial decisions so you can stay focused on growth.
              </p>
            </article>
          </div>

          <div className="about-us-two-col about-us-two-col-bottom">
            <article className="about-content-card about-content-card--strength">
              <p className="about-card-kicker">Team</p>
              <h3>Our Strength – Team of Brains</h3>
              <p>
                Every engagement is delivered by experienced professionals and domain specialists across:
              </p>
              <ul className="about-list about-list--chips">
                {teamAreas.map((area) => (
                  <li key={area}>{area}</li>
                ))}
              </ul>
              <p>
                Our team continuously upgrades expertise with evolving laws and industry practices to deliver timely,
                practical, and technically sound solutions.
              </p>
            </article>

            <article className="about-content-card about-content-card--approach">
              <p className="about-card-kicker">Approach</p>
              <h3>Our Approach</h3>
              <p>
                For us, professional service is not just compliance; it is trust, partnership, and long-term value.
              </p>
              <p className="about-list-intro">We strongly believe in:</p>
              <ul className="about-list about-list--two-col">
                {approachPoints.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <p className="about-emphasis">Our philosophy is simple: Client success is our success.</p>
            </article>
          </div>

        </div>
      </section>

      <section className="footer-section">
        <div className="container">
          <p>© {currentYear} Ritesh Shah &amp; Co. All rights reserved.</p>
          <p className="about-us-powered-by">
            Powered by{' '}
            <a href="https://elyspr.com/" target="_blank" rel="noopener noreferrer">
              Elyspr
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
